export default "__VITE_ASSET__C8S8tSnW__"